import { useSyncExternalStore } from 'react';

/**
 * Hook a média lekérdezések figyelésére.
 * @param query A figyelni kívánt média lekérdezés string (pl. "(min-width: 768px)").
 * @returns `true`, ha a lekérdezés megfelel, egyébként `false`.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = (callback: () => void) => {
    const mediaQueryList = window.matchMedia(query);

    // Régebbi böngészők támogatása (Safari < 14)
    if (mediaQueryList.addListener) {
      mediaQueryList.addListener(callback);
    } else {
      mediaQueryList.addEventListener('change', callback);
    }

    return () => {
      if (mediaQueryList.removeListener) {
        mediaQueryList.removeListener(callback);
      } else {
        mediaQueryList.removeEventListener('change', callback);
      }
    };
  };

  const getSnapshot = () => {
    return window.matchMedia(query).matches;
  };

  const getServerSnapshot = () => {
    return false;
  };

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** A shadcn `md` töréspontja: ez alatt mobil elrendezés (pl. dialógus helyett fiók) */
export const MOBILE_BREAKPOINT = 768;

/** `true` md alatt - a `ResponsiveDialog` és a kártya/táblázat váltások közös forrása */
export function useIsMobile(): boolean {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
